export const AppDrawerHeight = 240;
export const AppBarHeight = 64;

export const AlertsAutoHideDuration = 3000;
